import script from "./BlogSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogSearch.vue?vue&type=script&setup=true&lang=js"

import "./BlogSearch.vue?vue&type=style&index=0&id=d9aed2ea&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9aed2ea"]])

export default __exports__